import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";


const VoiceRecorder = ({ passSetVoiceText, lang = "en-US" }) => {

  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [partial, setPartial] = useState("");
  const [assistantText, setAssistantText] = useState("");
  const { t, i18n } = useTranslation();
  const [error, setError] = useState("");
  const recognitionRef = useRef(null);



  // Setup SpeechRecognition (Chrome/Edge support; Safari partial)
  useEffect(() => {

    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SR) {
      setError("SpeechRecognition not supported in this browser.");
      return;
    }

    const recognition = new SR();
    recognition.continuous = false;         // one utterance at a time
    recognition.interimResults = true;      // show live partials
    // recognition.lang = "en-US";
    recognition.lang = lang;

    recognition.onstart = () => {
      setError("");
      setTranscript("");
      setPartial("");
      setAssistantText("");
      setListening(true);
    };



    recognition.onerror = (e) => {
      setError(e.error || "Mic error");
      setListening(false);
    };

    recognition.onresult = (event) => {
      let finalText = "";
      let interimText = "";
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const chunk = event.results[i][0].transcript;
        if (event.results[i].isFinal) finalText += chunk;
        else interimText += chunk;
      }
      if (interimText) setPartial(interimText);
      if (interimText) passSetVoiceText(interimText);
      if (finalText) setTranscript((prev) => (prev ? prev + " " + finalText : finalText));
    };

    recognition.onend = () => {
      setListening(false);
    };

    recognitionRef.current = recognition;
    return () => {
      recognition.stop?.();
      recognitionRef.current = null;
    };
  }, []);


  // ✅ Update language when prop changes
  useEffect(() => {
    if (recognitionRef.current) {
      recognitionRef.current.lang = lang;
    }
  }, [lang]);

  const startListening = () => {
    if (!recognitionRef.current) return;
    setAssistantText("");
    setError("");
    try {
      recognitionRef.current.start();
    } catch (e) {
      // start() may throw if already started
    }
  };
  // end of useEffect


  const stopListening = () => {
    recognitionRef.current?.stop();
  };


  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <button
          onClick={listening ? stopListening : startListening}
          className={`px-4 py-2 rounded ${listening ? "bg-red-600 text-white" : "bg-blue-600 text-white"}`}
          aria-pressed={listening}
        >
          {listening ? t("voiceRecorder.stop") : t("voiceRecorder.start")} {t("voiceRecorder.mic")}
        </button>

      </div>

      {error && <p className="text-red-600 text-sm">Error: {error}</p>}

    </div>
  );
};

export default VoiceRecorder;
